// extracted by mini-css-extract-plugin
export default {"bgModal":"authModal_bgModal__2xGoR","modalContents":"authModal_modalContents__p1-xd","close":"authModal_close__SzjHt","button":"authModal_button__G3d2N"};